import { formatTime, formatTimeRange } from 'utils/date';
import { t } from 'localization';
import { EnumEnrouteStatus, EnumShipCustomerStatus } from 'constants/enum';
import { ReactComponent as FindingDriver } from 'assets/static/images/findingDriver.svg';
import { ReactComponent as DriverPicking } from 'assets/static/images/driverPicking.svg';
import { ReactComponent as DriverDelivering } from 'assets/static/images/driverDelivering.svg';
import { ReactComponent as DriverCancelled } from 'assets/static/images/driverCancelled.svg';
import { ReactComponent as DriverCompleted } from 'assets/static/images/driverCompleted.svg';
import { ReactComponent as DriverReturned } from 'assets/static/images/driverReturned.svg';
import { ReactComponent as StepSubmitted } from 'assets/static/images/stepSubmitted.svg';
import { ReactComponent as StepHeading } from 'assets/static/images/stepHeading.svg';
import { ReactComponent as StepPicked } from 'assets/static/images/stepPicked.svg';
import { ReactComponent as StepCompleted } from 'assets/static/images/stepCompleted.svg';
import { ReactComponent as StepCancelled } from 'assets/static/images/stepCancelled.svg';

export const StepType = {
  submitted: 'submitted',
  heading: 'heading',
  picked: 'picked',
  completed: 'completed',
  returned: 'returned',
  cancelled: 'cancelled',
};

const getStepSubmitted = (
  time,
  progress,
) => {
  return {
    type: StepType.submitted,
    icon: StepSubmitted,
    time: time
      ? t('order.status.time.submitted', {
        time: formatTime(time),
      })
      : undefined,
    progress,
  };
};
const getStepHeading = (
  time,
  progress,
) => {
  return {
    type: StepType.heading,
    icon: StepHeading,
    time: time
      ? t('order.status.time.assigned', {
        time: formatTime(time),
      })
      : undefined,
    progress,
  };
};
const getStepPicked = (time, progress) => {
  return {
    type: StepType.picked,
    icon: StepPicked,
    time: time
      ? t('order.status.time.picked', { time: formatTime(time) })
      : undefined,
    progress,
  };
};
const getStepCompleted = (
  time,
  progress,
) => {
  return {
    type: StepType.completed,
    icon: StepCompleted,
    time: time
      ? t('order.status.time.delivered', { time: formatTime(time) })
      : undefined,
    progress,
  };
};
const getStepReturned = (
  time,
  progress,
) => {
  return {
    type: StepType.returned,
    icon: StepCompleted,
    time: time
      ? t('order.status.time.returned', { time: formatTime(time) })
      : undefined,
    progress,
  };
};
const getStepCancelled = (
  time,
  progress,
) => {
  return {
    type: StepType.cancelled,
    icon: StepCancelled,
    time: time
      ? t('order.status.time.cancelled', { time: formatTime(time) })
      : undefined,
    progress,
  };
};
export const getOrderStatusStrategy = (detail) => {
  // Guard: empty data
  if (!detail) return;
  // 根据订单状态返回不同的展示策略
  const {
    status,
    enroute_status: enrouteStatus,
    create_time,
    assigned_time,
    pick_real_time,
    drop_real_time,
    return_time,
    cancel_time,
  } = detail;
  const createTime = Number(create_time || 0) * 1000;
  const assignedTime = Number(assigned_time || 0) * 1000;
  const pickRealTime = Number((pick_real_time) || 0) * 1000;
  const dropRealTime = Number(drop_real_time || 0) * 1000;
  const returnTime = Number(return_time || 0) * 1000;
  const cancelTime = Number(cancel_time || 0) * 1000;
  const currentEstimateTime = Number(detail?.data_by_status?.expected_times?.[detail?.data_by_status?.expected_times.length - 1]?.time || 0) * 1000;
  console.log('[getOrderStatusStrategy] status:', `${Object.entries(EnumShipCustomerStatus).find(([, v]) => v === status)?.[0]}`, status);
  switch (status) {
    case EnumShipCustomerStatus.INIT:
    case EnumShipCustomerStatus.ASSIGNING:
    case EnumShipCustomerStatus.ASSIGNING_TIMEOUT:
    case EnumShipCustomerStatus.COMING:
    case EnumShipCustomerStatus.IN_PROCESS:
    case EnumShipCustomerStatus.SCHEDULING: {
      return {
        steps: {
          title: t('order.status.created.title'),
          desc: t('order.status.created.desc'),
          icon: FindingDriver,
          seq: [
            getStepSubmitted(createTime, 100),
            getStepHeading(undefined, 50),
            getStepPicked(),
            getStepCompleted(),
          ],
        },
      };
    }
    case EnumShipCustomerStatus.ASSIGNED:
    case EnumShipCustomerStatus.SYSTEM_ASSIGNED: {
      if (enrouteStatus === EnumEnrouteStatus.PICKUP) {
        // EnroutePick
        return {
          steps: {
            title: t('order.status.enroute_pick.title'),
            desc: t('order.status.enroute_pick.desc'),
            est: currentEstimateTime ? t('order.est.pickup', {
              time: formatTimeRange(currentEstimateTime),
            }) : '',
            icon: DriverPicking,
            seq: [
              getStepSubmitted(createTime, 100),
              getStepHeading(assignedTime, 100),
              getStepPicked(undefined, 30),
              getStepCompleted(),
            ],
          },
          driver: {
            title: t('driver.status.enroute_pick.title'),
            desc: t('driver.status.enroute_pick.desc'),
          },
        };
      }
      return {
        steps: {
          title: t('order.status.assigned.title'),
          desc: t('order.status.assigned.desc'),
          icon: DriverPicking,
          seq: [
            getStepSubmitted(createTime, 100),
            getStepHeading(assignedTime, 100),
            getStepPicked(undefined, 1),
            getStepCompleted(),
          ],
        },
        driver: {
          title: t('driver.status.assigned.title'),
          desc: t('driver.status.assigned.desc'),
        },
      };
    }
    case EnumShipCustomerStatus.ARRIVED: {
      return {
        steps: {
          title: t('order.status.arrived.title'),
          desc: t('order.status.arrived.desc'),
          icon: DriverPicking,
          seq: [
            getStepSubmitted(createTime, 100),
            getStepHeading(assignedTime, 100),
            getStepPicked(undefined, 60),
            getStepCompleted(),
          ],
        },
        driver: {
          title: t('driver.status.arrived.title'),
          desc: t('driver.status.arrived.desc'),
        },
      };
    }
    case EnumShipCustomerStatus.PICKUP: {
      if (detail.enroute_status === EnumEnrouteStatus.DELIVERY) {
        // Enroute Delivery
        return {
          steps: {
            title: t('order.status.enroute_delivery.title'),
            desc: t('order.status.enroute_delivery.desc'),
            est: currentEstimateTime ? t('order.est.delivery', {
              time: formatTimeRange(currentEstimateTime),
            }) : '',
            icon: DriverDelivering,
            seq: [
              getStepSubmitted(createTime, 100),
              getStepHeading(assignedTime, 100),
              getStepPicked(pickRealTime, 100),
              getStepCompleted(undefined, 50),
            ],
          },
          driver: {
            title: t('driver.status.enroute_delivery.title'),
            desc: t('driver.status.enroute_delivery.desc'),
          },
        };
      }
      // Pickup
      return {
        steps: {
          title: t('order.status.picked.title'),
          desc: t('order.status.picked.desc'),
          icon: DriverDelivering,
          seq: [
            getStepSubmitted(createTime, 100),
            getStepHeading(assignedTime, 100),
            getStepPicked(pickRealTime, 100),
            getStepCompleted(undefined, 1),
          ],
        },
        driver: {
          title: t('driver.status.picked.title'),
          desc: t('driver.status.picked.desc'),
        },
      };
    }
    case EnumShipCustomerStatus.DELIVERY_PENDING: {
      return {
        steps: {
          title: t('order.status.on_hold.title'),
          desc: t('order.status.on_hold.desc'),
          icon: DriverDelivering,
          seq: [
            getStepSubmitted(createTime, 100),
            getStepHeading(assignedTime, 100),
            getStepPicked(pickRealTime, 100),
            getStepCompleted(undefined, 50),
          ],
        },
      };
    }
    case EnumShipCustomerStatus.RETURNING:
    case EnumShipCustomerStatus.RETURN_TO_HUB:
    case EnumShipCustomerStatus.RETURNING_TO_HUB:
    case EnumShipCustomerStatus.DELIVERY_RETRY: {
      return {
        steps: {
          title: t('order.status.returning.title'),
          desc: t('order.status.returning.desc'),
          // 算的不准, 隐藏
          // est: currentEstimateTime ? t('order.est.return', {
          //   time: formatTimeRange(currentEstimateTime),
          // }) : '',
          icon: DriverDelivering,
          seq: [
            getStepSubmitted(createTime, 100),
            getStepHeading(assignedTime, 100),
            getStepPicked(pickRealTime, 100),
            getStepCompleted(undefined, 50),
          ],
        },
      };
    }
    case EnumShipCustomerStatus.RETURN_SUCCESS: {
      return {
        steps: {
          title: t('order.status.returned.title'),
          desc: t('order.status.returned.desc'),
          icon: DriverReturned,
          seq: [
            getStepSubmitted(createTime, 100),
            getStepHeading(assignedTime, 100),
            getStepPicked(pickRealTime, 100),
            getStepReturned(returnTime, 100),
          ],
        },
      };
    }
    case EnumShipCustomerStatus.COMPLETED: {
      // Delivered
      return {
        steps: {
          title: t('order.status.delivered.title'),
          desc: t('order.status.delivered.desc'),
          icon: DriverCompleted,
          seq: [
            getStepSubmitted(createTime, 100),
            getStepHeading(assignedTime, 100),
            getStepPicked(pickRealTime, 100),
            getStepCompleted(dropRealTime, 100),
          ],
        },
      };
    }
    case EnumShipCustomerStatus.USER_CANCELED:
    case EnumShipCustomerStatus.SYSTEM_CANCELED:
    case EnumShipCustomerStatus.RECLAIMED:
    case EnumShipCustomerStatus.PICKUP_FAILED:
    case EnumShipCustomerStatus.DRIVER_CANCELED: {
      return {
        steps: {
          title: t('order.status.cancelled.title'),
          desc: t('order.status.cancelled.desc'),
          icon: DriverCancelled,
          seq: [
            getStepSubmitted(createTime, 100),
            getStepCancelled(cancelTime, 100),
          ],
        },
      };
    }
    case EnumShipCustomerStatus.RETURN_FAILED: {
      return {
        steps: {
          title: t('order.status.cancelled.title'),
          desc: t('order.status.cancelled.desc'),
          est: t('order.status.time.cancelled', { time: formatTime(currentEstimateTime) }),
          icon: DriverDelivering, // 行吧
          seq: [
            getStepSubmitted(createTime, 100),
            getStepHeading(assignedTime, 100),
            getStepPicked(pickRealTime, 100),
            getStepCompleted(dropRealTime, 100),
          ],
        },
      };
    }
    default:
      return undefined;
  }
};
